<template>
  <tip-form
    v-if="tip"
    action="update"
    :loading="loading"
    :updating="updating"
    :data="tip"
    :error-messages="errorMessages"
    :handle-submit="handleFormSubmit"
    :handle-discard="handleDiscard"
  />
</template>

<script>
// eslint-disable-next-line object-curly-newline, no-unused-vars
import { onUnmounted, ref, computed, provide, getCurrentInstance } from '@vue/composition-api'

import { useRouter } from '@core/utils'
import useTipView from './useTipView'

import TipForm from './tip-form/TipForm.vue'

export default {
  components: {
    TipForm,
  },
  setup() {
    const vm = getCurrentInstance().proxy
    const { route } = useRouter()

    const {
      tip,
      loading,
      updating,

      errorMessages,

      init,
      destroy,

      updateData,
    } = useTipView(route.value.params.id)

    // Init
    init()

    // Destroy
    onUnmounted(() => {
      destroy()
    })

    // const tipDataLocal = computed(() => tip.value)

    const handleFormSubmit = formData => updateData(formData)
    const handleDiscard = () => vm.$router.replace({ name: 'tip-view', params: { id: route.value.params.id } })

    return {
      tip,
      loading,
      updating,
      updateData,

      errorMessages,

      // tipDataLocal,

      handleFormSubmit,
      handleDiscard,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
